
import tasksApi from '@/api/tasks';

export default {
  name: 'ClientTaskSelect',

  props: {
    value: {
      type: String | null,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    client: {
      type: Object | null,
      required: true,
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      loading: true,
      tasks: [],
    };
  },

  computed: {
    selectedList: {
      get: function () {
        if (this.value) {
          return this.tasks.filter((item) => this.value.includes(item.uuid));
        }
      },
      set: function (newVal) {
        if (newVal) {
          this.$emit('input', newVal.uuid);
        } else {
          this.$emit('input', null);
        }
      },
    },
  },

  mounted() {
    if (this.client !== null && this.client !== undefined) {
      this.getTasks(this.client);
    }
  },

  methods: {
    getTasks(client) {
      this.loading = true;
      tasksApi
        .getAllTasks({
          params: {
            'filter[taskable_uuid]': client.uuid,
            'filter[taskable_type]': 'client',
            'filter[show_child_tasks]': true,
            per_page: 250,
          },
        })
        .then((rsp) => {
          this.tasks = rsp.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$nuxt.$emit('notification', err.response.data.message, 'warning', true);
        });
    },
  },

  watch: {
    client(new_val) {
      if (new_val !== null && new_val !== undefined) {
        this.getTasks(new_val);
      }
    },
  },
};
